import React, { PropTypes, Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import _ from "underscore";

import * as jobsActions from "../actions/jobsActions";

import JobList from "../components/jobList";
import JobDetails from "../components/jobDetails";
import NoRecords from "../../util/noRecords";
import Controls from '../../util/controls';

class JobsPage extends Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (this.props.auth.selectedClientId && this.props.auth.selectedMerchantId)
      this.props.actions.getJobList(this.props.auth.selectedClientId, this.props.auth.selectedMerchantId);
  }

  render() {
    let { jobId, status } = this.props.routeParams;

    let mode = "list";
    let matchingJob = {};
    let jobs = [];

    if (jobId) {
      jobs = [...this.props.jobs.openJobs, ...this.props.jobs.closedJobs]
      matchingJob = _.find(jobs, function (item) { return item.jobID.toString() === jobId });
      mode = "details";
    }
    else
      jobs = (status != "closed" ? this.props.jobs.openJobs : this.props.jobs.closedJobs);

    return (
      this.props.ajaxCallCount > 0 ? <Controls.LoadingPanel /> :
        <div className="jobs" >

          {mode === "details" && <JobDetails details={matchingJob} />}
          {
            mode === "list" && (jobs && jobs.length > 0 ? (
              <div>
                <h2 className="client-text">{(status != "closed" ? "Open" : "Closed")} Jobs</h2>
                <JobList jobs={jobs} status={status} showOnlyShortList={this.props.showOnlyShortList} />
              </div>
            )
              :
              (
                <NoRecords type="Jobs" />
              ))
          }
        </div >

    );
  }

}

function mapStateToProps(state) {
  return {
    jobs: state.jobs,
    auth: state.auth,
    ajaxCallCount: state.core.ajaxCallCount
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(jobsActions, dispatch)
  };
}


export default connect(mapStateToProps, mapDispatchToProps)(JobsPage);


// WEBPACK FOOTER //
// ./app/jobs/containers/jobsPage.js